import { useCallback } from 'react'

const useOffsetDate = () => {
  return useCallback((dte: Date) => {
    const offset = dte.getTimezoneOffset() * 60 * 1000
    return new Date(dte.getTime() + offset)
  }, [])
}

export default useOffsetDate
